import type { BankRate } from "web_myplann/Calculators/Types/BankRate";
import type { CalculatorRateBar } from "web_myplann/Calculators/Types/CalculatorRateBar";

type Labels = {
	bankLabel: (index: number) => string;
	bankRangeLabel: (from: number, to: number) => string;
	notOffered: string;
};

export const mapBankRateBars = (
	rates: BankRate[],
	labels: Labels,
): CalculatorRateBar[] => {
	const offered = rates
		.filter((rate) => rate.status === "ok")
		.sort((a, b) => a.rate - b.rate);
	const rejected = rates.filter((rate) => rate.status === "fail");

	const bars: CalculatorRateBar[] = offered.map((rate, index) => ({
		label: labels.bankLabel(index + 1),
		rate: rate.rate,
		isEmphasized: index === 0,
	}));

	if (rejected.length === 0) {
		return bars;
	}

	const from = offered.length + 1;
	const to = offered.length + rejected.length;

	bars.push({
		label:
			rejected.length === 1
				? labels.bankLabel(from)
				: labels.bankRangeLabel(from, to),
		note: labels.notOffered,
		isEmphasized: false,
	});

	return bars;
};
